export default __webpack_public_path__ + "static/media/sun.961657ed.png";